// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","root":"root-15n67","group":"group-1OgBG","items":"items-3RmzX","dateSeparator":"dateSeparator-1kYQs"};